import React from 'react';
import { MarkButton } from '../../../components/MarkControls';
import JourneyCanvas from './JourneyCanvas';
import CheckSegmentCard from './CheckSegmentCard';
import ActivityCard from './ActivityCard';
import AbSplitCard from './AbSplitCard';
import type { DripStep } from '../../../types';
type Props = {
    steps: DripStep[];
    entryStepId: string | null;
    onEditSteps?: () => void;
    onEditTemplate?: (stepId: string) => void;
};
const StepCard: React.FC<{
    step: DripStep;
    hasLegalCycle: boolean;
    onEditTemplate?: (stepId: string) => void;
}> = ({ step, hasLegalCycle, onEditTemplate }) => {
    switch (step.type) {
        case 'check_segment':
            return <CheckSegmentCard step={step} hasLegalCycle={hasLegalCycle} />;
        case 'activity':
            return <ActivityCard step={step} onEditTemplate={onEditTemplate} />;
        case 'ab_split':
            return <AbSplitCard step={step} />;
    }
};
const StepCanvas: React.FC<Props> = ({ steps, entryStepId, onEditTemplate, onEditSteps }) => (
    <JourneyCanvas
        steps={steps}
        entryStepId={entryStepId}
        headerActions={
            onEditSteps ? (
                <MarkButton compact onClick={onEditSteps}>
                    Edit steps
                </MarkButton>
            ) : undefined
        }
        renderStep={(step, context) => (
            <StepCard
                step={step}
                hasLegalCycle={context.hasLegalCycle}
                onEditTemplate={onEditTemplate}
            />
        )}
    />
);
export default StepCanvas;
